import { Component, Input } from '@angular/core';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { Seat } from '../../models/team/seat';

@Component({
  selector: 'profile-custom-field',
  templateUrl: './profile-custom-field.component.html',
  styleUrls: ['./profile-custom-field.component.scss'],
})
export class ProfileCustomFieldComponent {
  @Input() showEmpty: boolean = true;
  @Input() customFields: AttributeDefinition[];
  @Input() customFieldValues: Attribute[];
  /**optional. Only required if editing team fields */
  @Input() seat: Seat;

  public getCustomFieldValueByTypeId(attributeDefinitionId: string): Array<Attribute> {
    return this.customFieldValues?.filter((a) => a.attributeDefinitionId == attributeDefinitionId);
  }
  public isEmpty = (attributeDefinition: AttributeDefinition) => {
    if (!this.customFieldValues) {
      return true;
    }
    return !this.customFieldValues.find((a) => a.attributeDefinitionId == attributeDefinition.id);
  };
}
